module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-vault-3.99722c66.svg";